import {
  ApiError,
  CldbHistoryOfChangesEntry,
  ClinicServices,
  HistoryOfChangeDetails,
  HistoryOfHoursChange,
  HistoryOfOrganizationChange,
  HistoryOfServicesChange,
  Site,
  SiteDetails,
  UserGrantSelection,
} from '@core/models';

export interface State {
  associatedGrant: UserGrantSelection;
  associatedGrantError: ApiError;
  associatedGrantLoading: boolean;
  clinicServices: ClinicServices[];
  createSiteError: ApiError;
  createSiteLoading: boolean;
  currentSiteId: string;
  getClinicServicesError: ApiError;
  getClinicServicesLoading: boolean;
  historyOfChanges: CldbHistoryOfChangesEntry[];
  historyOfChangesError: ApiError;
  historyOfChangesLoading: boolean;
  historyOfChangeDetails:
    | HistoryOfChangeDetails<HistoryOfOrganizationChange>
    | HistoryOfChangeDetails<HistoryOfHoursChange>
    | HistoryOfChangeDetails<HistoryOfServicesChange>;
  historyOfChangeDetailsError: ApiError;
  historyOfChangeDetailsLoading: boolean;
  noaFile: File;
  noaFilePresignedUrl: string;
  noaFilePresignedUrlError: ApiError;
  noaFilePresignedUrlLoading: boolean;
  publishSiteError: ApiError;
  publishSiteLoading: boolean;
  removeSiteError: ApiError;
  removeSiteLoading: boolean;
  siteDetails: SiteDetails;
  siteDetailsError: ApiError;
  siteDetailsLoading: boolean;
  sites: Site[];
  sitesError: ApiError;
  sitesLoading: boolean;
  updateServicesError: ApiError;
  updateServicesLoading: boolean;
  updateSiteError: ApiError;
  updateSiteHoursError: ApiError;
  updateSiteHoursLoading: boolean;
  updateSiteLoading: boolean;
}

export const initialState: State = {
  associatedGrant: {
    grantId: null,
    subrecipientId: null,
  },
  associatedGrantError: null,
  associatedGrantLoading: false,
  clinicServices: null,
  createSiteError: null,
  createSiteLoading: false,
  currentSiteId: null,
  getClinicServicesError: null,
  getClinicServicesLoading: false,
  historyOfChanges: [],
  historyOfChangesError: null,
  historyOfChangesLoading: false,
  historyOfChangeDetails: null,
  historyOfChangeDetailsError: null,
  historyOfChangeDetailsLoading: false,
  noaFile: null,
  noaFilePresignedUrl: null,
  noaFilePresignedUrlError: null,
  noaFilePresignedUrlLoading: false,
  publishSiteError: null,
  publishSiteLoading: false,
  removeSiteError: null,
  removeSiteLoading: false,
  siteDetails: null,
  siteDetailsError: null,
  siteDetailsLoading: false,
  sites: [],
  sitesError: null,
  sitesLoading: false,
  updateServicesError: null,
  updateServicesLoading: false,
  updateSiteError: null,
  updateSiteHoursError: null,
  updateSiteHoursLoading: false,
  updateSiteLoading: false,
};
